import { Box } from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AutoCompleteCity from "shared/components/autoCompleteCity";
import Filter from "shared/components/filterButton";
import PaginationComponent from "shared/components/pagination";
import Individual from "shared/components/projectHeadComponents/dashboard/accountsDetails/individualTable";
import Parent from "shared/components/projectHeadComponents/dashboard/accountsDetails/parentTable";
import School from "shared/components/projectHeadComponents/dashboard/accountsDetails/schoolTable";
import RangeDatePicker from "shared/components/rangeDatePicker";
import StatsCard from "shared/components/statsCard";
import { toastMessage } from "shared/components/toast";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import useDebounce from "shared/customHooks/useDebounce";
import Confirmation from "shared/modals/confirmation";
import { routeConstant } from "shared/routes/routesConstant";
import { getAllAgeRangesService } from "shared/services/general";
import Loader from "shared/components/loader/animation";
import {
  blockUserService,
  getUserListings,
  getUserOverallStats,
  unblockUserService,
} from "shared/services/projectHeadService";
import { user_roles } from "shared/utils/constants";
import UserGraph from "../../shared/components/projectHeadComponents/dashboard/accountsDetails/graph";
import styles from "./style.module.scss";
import { filterOption, statusFilterOptions } from "./constant";

function AccountsDetail() {
  const params = useParams();
  const keyword: any = params?.keyword;
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(new Date());
  const [selectedCity, setSelectedCity] = useState<any>(null);
  const [allAgeRanges, setAllAgeRanges] = useState<any>();
  const [selectedAgeRange, setSelectedAgeRange] = useState<any>(null);
  const [searchTable, setSearchTable] = useState<string>("");
  const [search, setSearch] = useState<string>("");
  const [stats, setStats] = useState<any>([]);
  const [searchText, setSearchText] = useState<string>("");
  const [statsLoader, setStatsLoader] = useState<boolean>(false);
  const [allTimeRecord, setAllTimeRecord] = useState<boolean>(false);
  const [users, setUsers] = useState<any>([]);
  const [usersLoader, setUsersLoader] = useState<boolean>(true);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [activePage, setActivePage] = useState<number>(1);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [actionLoader, setActionLoader] = useState<boolean>(false);
  const [selectedAgeForTable, setSelectedAgeForTable] = useState<any>(null);
  const [selectedFilter, setSelectedFilter] = useState<any>(null);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState<any>(null);

  const [action, setAction] = useState<any>({
    label: "",
    type: "",
  });
  const [selectedItem, setSelectedItem] = useState<any>(null);
  //eslint-disable-next-line
  const [activeRole, setActiveRole] = useState<number | null>(
    keyword === "individuals"
      ? user_roles.reader
      : keyword === "parents"
      ? user_roles.parent
      : keyword === "schools"
      ? user_roles.school
      : null
  );

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setSelectedItem(null);
  };

  const handleOpenConfirm = (label: String, type: String, item: any) => {
    setOpenConfirm(true);
    setAction({
      label: label,
      type: type,
    });
    setSelectedItem(item);
  };

  useBreadcrumbs(
    {
      title:
        keyword.charAt(0).toUpperCase() +
        keyword.slice(1).toLowerCase() +
        "' Detail",
      path: routeConstant.usersAccountsDetail.path.replace(":keyword", keyword),
    },
    true,
    keyword
  );

  let statsCard = [
    {
      label: "Free Accounts",
      count: stats?.free,
    },
    {
      label: "Premium Accounts",
      count: stats?.premium,
    },
    {
      label: "Deactivated Accounts",
      count: stats?.deactive,
    },
    {
      label: "New Subscribers",
      count: stats?.new_subs,
    },
    {
      label: "Expired Accounts",
      count: stats?.expired,
    },
    {
      label: "Repurchased Accounts",
      count: stats?.repurchase,
    },
  ];

  const topCities = [
    { city: "Tokyo", country: "Japan" },
    { city: "Delhi", country: "India" },
    { city: "Shanghai", country: "China" },
    { city: "São Paulo", country: "Brazil" },
    { city: "Mexico City", country: "Mexico" },
    { city: "Cairo", country: "Egypt" },
    { city: "Mumbai", country: "India" },
    { city: "Beijing", country: "China" },
    { city: "Dhaka", country: "Bangladesh" },
    { city: "Osaka", country: "Japan" },
    { city: "New York City", country: "USA" },
    { city: "Karachi", country: "Pakistan" },
    { city: "Buenos Aires", country: "Argentina" },
    { city: "Kolkata", country: "India" },
    { city: "Istanbul", country: "Turkey" },
    { city: "Chongqing", country: "China" },
    { city: "Lagos", country: "Nigeria" },
    { city: "Manila", country: "Philippines" },
    { city: "Rio de Janeiro", country: "Brazil" },
    { city: "Guangzhou", country: "China" },
    { city: "Moscow", country: "Russia" },
    { city: "Tianjin", country: "China" },
    { city: "Jakarta", country: "Indonesia" },
    { city: "London", country: "United Kingdom" },
    { city: "Lima", country: "Peru" },
    { city: "Bangkok", country: "Thailand" },
    { city: "Paris", country: "France" },
    { city: "Hong Kong", country: "China" },
    { city: "Chennai", country: "India" },
    { city: "Hyderabad", country: "India" },
    { city: "New York", country: "USA" },
    { city: "Berlin", country: "Germany" },
  ];

  const getAllAgeRanges = () => {
    getAllAgeRangesService()
      .then(({ data }) => {
        // console.log("Data", data?.data);
        let obj: any = [];
        data?.data?.forEach((itm: any) => {
          obj.push({
            id: itm?.id,
            option: itm?.text,
            value: itm?.id,
          });
        });
        setAllAgeRanges(obj);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (keyword === "individuals") {
      getAllAgeRanges();
    }
    // eslint-disable-next-line
  }, []);

  ///////////

  const getStatsDetail = () => {
    setStatsLoader(true);
    getUserOverallStats(
      Number(activeRole),
      allTimeRecord
        ? null
        : {
            from: moment(startDate).format("YYYY-MM-DD"),
            to: moment(endDate).format("YYYY-MM-DD"),
          }
    )
      .then(({ data }) => {
        setStats(data?.data);
        setStatsLoader(false);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getUsers = () => {
    setUsersLoader(true);
    getUserListings(
      Number(activeRole),
      activePage,
      searchText,
      selectedAgeForTable,
      selectedFilter,
      selectedStatusFilter,
      allTimeRecord
        ? null
        : {
            from: moment(startDate).format("YYYY-MM-DD"),
            to: moment(endDate).format("YYYY-MM-DD"),
          }
    )
      .then(({ data: { data } }) => {
        setUsers(data?.data);
        setUsersLoader(false);
        setTotalPage(data?.last_page);
      })
      .catch((err) => {
        console.log("err", err);
        setUsersLoader(false);
      });
  };

  useEffect(() => {
    if (startDate && endDate) {
      getStatsDetail();
    }

    //eslint-disable-next-line
  }, [startDate, endDate, allTimeRecord]);

  useEffect(() => {
    if (startDate && endDate) {
      getUsers();
    }

    //eslint-disable-next-line
  }, [
    startDate,
    endDate,
    activePage,
    allTimeRecord,
    searchText,
    selectedAgeForTable,
    selectedFilter,
    selectedStatusFilter,
  ]);

  //////////

  const handleAction = (action: any) => {
    let service =
      action?.type === "deactivate"
        ? blockUserService
        : action?.type === "activate"
        ? unblockUserService
        : null;

    setActionLoader(true);
    service?.(selectedItem?.id)
      .then(({ data }) => {
        toastMessage("success", data?.message);
        handleCloseConfirm();
        getUsers();
        setActionLoader(false);
      })
      .catch((err) => {
        toastMessage("error", err?.response.data?.message);
        console.log("error", err?.response.data?.message);
        setActionLoader(false);
      });
  };

  useDebounce(
    () => {
      setSearchText(searchTable);
    },
    [searchTable],
    800
  );

  return (
    <div className={styles.mainContainer}>
      <Box display={"flex"} alignItems={"center"}>
        <span className={styles.heading}>
          Total {stats?.total}{" "}
          {keyword === "individuals"
            ? "Kids"
            : keyword === "parents"
            ? "Parents"
            : keyword === "schools"
            ? "School"
            : ""}{" "}
          Account
        </span>
      </Box>

      <StatsCard
        statsList={statsCard}
        label="Account Stats"
        loader={statsLoader}
      />

      <div className={styles.btnContainer}>
        <button
          className={classNames(
            styles.allTimeBtn,
            allTimeRecord && styles.allTimeSelectedBtn
          )}
          onClick={() => {
            setAllTimeRecord(!allTimeRecord);
            setActivePage(1);
          }}
        >
          All
        </button>
        <div className={styles.dateContainer}>
          {
            <RangeDatePicker
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={(date: Date | null) => {
                setEndDate(date);
                setActivePage(1);
              }}
              doubleLabel={true}
              noDateSelected={allTimeRecord}
            />
          }
        </div>
      </div>

      <div className={styles.infoContainer}>
        <div className={styles.filterContainer}>
          {keyword === "individuals" && (
            <div>
              <Filter
                label="Search by Age"
                filterOption={allAgeRanges}
                filterStyles={styles.filterStyles}
                selectedOption={selectedAgeRange}
                setSelectedOption={setSelectedAgeRange}
                labelStyle={styles.filterStyles}
                filterBtnStyles={styles.filterBtn}
              />
            </div>
          )}
          <div className={styles.cityFilter}>
            <AutoCompleteCity
              list={topCities}
              setSearchText={setSearch}
              searchText={search}
              selectedItem={selectedCity}
              setSelectedItem={(city: any) => {
                setSelectedCity(city);
              }}
            />
          </div>
        </div>

        <div className={styles.graphContainer}>
          <div>
            <UserGraph allTimeRecord={allTimeRecord}  selectedAgeRange={selectedAgeRange} />
          </div>
        </div>

        <div className={styles.mainTableContainer}>
          <Box className={styles.filterContainer}>
            {keyword === "individuals" && (
              <div>
                <Filter
                  label="Search by Age"
                  filterOption={allAgeRanges}
                  labelStyle={styles.filterStyles}
                  selectedOption={selectedAgeForTable}
                  setSelectedOption={setSelectedAgeForTable}
                  setActivePage={setActivePage}
                />
              </div>
            )}

            <div className={styles.userFilter}>
              <Filter
                label="Membership Status"
                filterOption={filterOption}
                labelStyle={styles.filterStyles}
                selectedOption={selectedFilter}
                setSelectedOption={setSelectedFilter}
                setActivePage={setActivePage}
              />
            </div>

            {keyword === "schools" && (
              <div className={styles.userFilter}>
                <Filter
                  label="Status"
                  filterOption={statusFilterOptions}
                  labelStyle={styles.filterStyles}
                  selectedOption={selectedStatusFilter}
                  setSelectedOption={setSelectedStatusFilter}
                  setActivePage={setActivePage}
                />
              </div>
            )}

            <div className={styles.gridContainer}>
              <Icons.SearchIcon className={styles.searchIcon} />
              <input
                placeholder="Search"
                className={styles.input}
                value={searchTable}
                onChange={(e) => {
                  setSearchTable(e.target.value);
                  setActivePage(1);
                }}
              />
            </div>
          </Box>
          {keyword === "individuals" ? (
            <Individual
              usersLoader={usersLoader}
              users={users}
              keyword={keyword}
              handleOpenConfirm={handleOpenConfirm}
            />
          ) : keyword === "parents" ? (
            <Parent
              usersLoader={usersLoader}
              users={users}
              keyword={keyword}
              handleOpenConfirm={handleOpenConfirm}
            />
          ) : keyword === "schools" ? (
            <School
              usersLoader={usersLoader}
              users={users}
              keyword={keyword}
              handleOpenConfirm={handleOpenConfirm}
            />
          ) : null}

          {!(users?.length > 0) && !usersLoader && (
            <div className={styles.noUserCard}>
              <Icons.TableEmptyIcon />
              <h5 className={styles.noDataLabel}>No Data Found</h5>
            </div>
          )}

          {totalPage > 1 && (
            <PaginationComponent
              totalPages={totalPage}
              activePage={activePage}
              setActivePage={setActivePage}
            />
          )}
        </div>

        <Confirmation
          text={action.label}
          handleClose={handleCloseConfirm}
          open={openConfirm}
          handleClick={() => handleAction(action)}
        />
      </div>

      {actionLoader && <Loader />}
    </div>
  );
}

export default AccountsDetail;
